window.config = {
  REACT_APP_CONNECT_API_URL: process.env.REACT_APP_CONNECT_API_URL,
  DASHBOARD_TYPE: process.env.REACT_APP_DASHBOARD_TYPE,
  OPENID_CONFIG: JSON.parse(process.env.REACT_APP_OPENID_CONFIG || '{}'),
  HOST: process.env.REACT_APP_HOST,
  CONNECT_URLS: JSON.parse(process.env.REACT_APP_CONNECT_URLS),
  PROGRAM_ID: process.env.REACT_APP_PROGRAM_ID,
  NODE_ENV: process.env.NODE_ENV
};
